import {AccessPermission} from "~/enums/accessPermission";
import {generateEnumHash} from "~/helpers/enumHelper";
import {Hash} from "~/interfaces/hashInterfaces";

export enum ObjectModelBuiltinPropertyType {
  CreatedAt = 1,
  CreatedBy =  2,
  UpdatedAt = 3,
  RecordHolderName = 4,
  RecordHolderEmail = 5,
  RecordId = 6,
}

export enum ObjectModelBuiltinCategory {
  AboutRecord = "About Record",
  ClaimingRecord = "Claiming Record",
  EstablishRelationship = "Establish Relationship",
  FormabilityId = "Formability ID",
}

const o = ObjectModelBuiltinPropertyType
export const allBuiltinMappingValues: Array<ObjectModelBuiltinPropertyType> = [
  o.CreatedAt,
  o.CreatedBy,
  o.UpdatedAt,
  o.RecordHolderName,
  o.RecordHolderEmail,
  o.RecordId,
]

export interface IObjectModelBuiltinPropertyDetail {
  type: ObjectModelBuiltinPropertyType
  displayName: string
  propertyName: string
  permissions: Array<AccessPermission>
  category: ObjectModelBuiltinCategory
  tooltip?: string
}

/**
 * Consider these as defaults.
 * @see ObjectModelPropertyDefinition.builtInTypesSet
 */
export const ObjectModelBuiltinPropertyDetails: {[key in ObjectModelBuiltinPropertyType]?: IObjectModelBuiltinPropertyDetail} = {
  [ObjectModelBuiltinPropertyType.CreatedAt]: {
    type: ObjectModelBuiltinPropertyType.CreatedAt,
    displayName: "Record Created On",
    propertyName: "c_at",
    permissions: [AccessPermission.Read],
    category: ObjectModelBuiltinCategory.AboutRecord
  },
  [ObjectModelBuiltinPropertyType.CreatedBy]: {
    type: ObjectModelBuiltinPropertyType.CreatedBy,
    displayName: "Record Created By",
    propertyName: "creator",
    permissions: [AccessPermission.Read],
    category: ObjectModelBuiltinCategory.AboutRecord
  },
  [ObjectModelBuiltinPropertyType.UpdatedAt]: {
    type: ObjectModelBuiltinPropertyType.UpdatedAt,
    displayName: "Record Last Updated On",
    propertyName: "u_at",
    permissions: [AccessPermission.Read],
    category: ObjectModelBuiltinCategory.AboutRecord
  },
  [ObjectModelBuiltinPropertyType.RecordHolderName]: {
    type: ObjectModelBuiltinPropertyType.RecordHolderName,
    displayName: "Record Holder Name",
    propertyName: "owner",
    permissions: [AccessPermission.Read],
    category: ObjectModelBuiltinCategory.AboutRecord
  },
  [ObjectModelBuiltinPropertyType.RecordHolderEmail]: {
    type: ObjectModelBuiltinPropertyType.RecordHolderEmail,
    displayName: "Record Holder Email",
    propertyName: "owner_email",
    permissions: [AccessPermission.Read, AccessPermission.Write],
    category: ObjectModelBuiltinCategory.ClaimingRecord
  },
  [ObjectModelBuiltinPropertyType.RecordId]: {
    type: ObjectModelBuiltinPropertyType.RecordId,
    displayName: "Record ID",
    propertyName: "id",
    permissions: [AccessPermission.Read],
    category: ObjectModelBuiltinCategory.EstablishRelationship
  },
}

function getAttr(enumVal, attr) {
  return ObjectModelBuiltinPropertyDetails[enumVal][attr]
}

function generatePropertyTypeHash(attr): Hash {
  return generateEnumHash(ObjectModelBuiltinPropertyType, getAttr, attr)
}

export const ObjectModelBuiltinPropertyTypeName = generatePropertyTypeHash('displayName');
export const ObjectModelBuiltinPropertyAttrName = generatePropertyTypeHash('propertyName');
export const ObjectModelBuiltinPropertyPermissions = generatePropertyTypeHash('permissions');
export const ObjectModelBuiltinPropertyCategories = generatePropertyTypeHash('category');


export function isObjectModelBuiltinPropertyAccess(enumVal: ObjectModelBuiltinPropertyType, array: Array<AccessPermission>, exact: boolean = true) {
  const permissions = ObjectModelBuiltinPropertyPermissions[enumVal];
  return permissions.every(e => {
    return array.includes(e)
  }) && array.length === permissions.length;
}